/**
 * Runtime detection for the Tauri desktop shell.
 * Prefer the window userAgent marker (set in src-tauri/tauri.conf.json) — it is
 * available on first paint. Do NOT set window.__TAURI_DESKTOP__ (forces headless UI).
 */ export const isTauriApp = ()=>{
    if (typeof window === 'undefined') {
        return false;
    }
    if (typeof navigator !== 'undefined' && /RocketlaneDesktop/i.test(navigator.userAgent)) {
        return true;
    }
    return '__TAURI_INTERNALS__' in window || '__TAURI__' in window || Boolean(window.isTauri);
};
